import MuiList from "@mui/material/List";
import { withStyles } from "@mui/styles";

const List = withStyles({
  root: props => {
    if (props.display === "inline") {
      return {
        display: "flex",
        flexDirection: "row",
        padding: 0,
      };
    }
  },
})(MuiList);

export default List;
